import React, {useEffect, useState} from 'react'
import { useNavigate } from "react-router-dom";
import { collection, getDocs, query, where } from 'firebase/firestore'
import { Button, Spacer } from '@umahealth/occipital-ui'
import { db } from '../../config/firebase'

export default function ActiveModelsList() {
    const navigate = useNavigate();
    const [activeModels, setActiveModels] = useState([])

    useEffect(() => {
        queryPrueba()
    }, [])

    const queryPrueba = async () => {
        try { // /prototypes/cardiovascular
            const prototypesQueries = query(collection(db, "prototypes"), where("active", "==", true))
            const querySnapshot = await getDocs(prototypesQueries)
            const models = []
            querySnapshot.forEach((doc) => {
                models.push({ ...doc.data(), id: doc.ref.id})
            });
            setActiveModels(models)
        } catch (e) {
            console.error("Error adding document: ", e);
        }
    }

  return (
    <div>
        {activeModels.map((currentModel) =>{
        return <div key={currentModel.id}>
                <Spacer />
                <Button 
                    options={{'size': 'medium', 'type': 'text'}}
                    action={() => navigate(`/model/${currentModel.id}`)}
                    >
                        {currentModel.id}
                </Button>
            </div>
    })}</div>
  )
}
